/**
 * Shim for `@react-native-async-storage/async-storage`, backed by
 * `window.localStorage` with the same Promise-based API.
 */
const AsyncStorage = {
  async getItem(key: string): Promise<string | null> {
    return window.localStorage.getItem(key);
  },
  async setItem(key: string, value: string): Promise<void> {
    window.localStorage.setItem(key, value);
  },
  async removeItem(key: string): Promise<void> {
    window.localStorage.removeItem(key);
  },
  async clear(): Promise<void> {
    window.localStorage.clear();
  },
  async getAllKeys(): Promise<string[]> {
    return Object.keys(window.localStorage);
  },
  async multiGet(keys: string[]): Promise<[string, string | null][]> {
    return keys.map((k) => [k, window.localStorage.getItem(k)]);
  },
  async multiSet(pairs: [string, string][]): Promise<void> {
    pairs.forEach(([k, v]) => window.localStorage.setItem(k, v));
  },
  async multiRemove(keys: string[]): Promise<void> {
    keys.forEach((k) => window.localStorage.removeItem(k));
  },
  async mergeItem(key: string, value: string): Promise<void> {
    const existing = window.localStorage.getItem(key);
    if (!existing) {
      window.localStorage.setItem(key, value);
      return;
    }
    try {
      const merged = { ...JSON.parse(existing), ...JSON.parse(value) };
      window.localStorage.setItem(key, JSON.stringify(merged));
    } catch {
      window.localStorage.setItem(key, value);
    }
  },
};

export default AsyncStorage;
